module.exports = __webpack_public_path__ + "static/media/cat_icon.498de577.png";